import React, { useRef } from 'react';

import './HomePage.css';
import { Helmet } from 'react-helmet-async';
import EmailSubscription from '../components/HomeSection/EmailSubscription';
import WhyCognitva from '../components/HomeSection/WhyCognitva';
import WhyNow from '../components/HomeSection/WhyNow';
import RequestInfo from '../components/RequestInfo/RequestInfo';
import featureFlags from '../configuration/featureFlags';
import Testimonials from '../components/HomeSection/Testimonials';
import { Divider } from 'antd';

const HomePage = () => {
  const sectionRef = useRef(null);

  // Dummy data for capabilities, similar to HeroSection's pills
  const topRowPills = [
    {
      text: <span>80% Reusable AI Core that accelerates go-to-market across Legal, Healthcare, Finance, ESG & Energy, and more</span>
    },
    {
      text: <span>Intelligent Copilots for Contracts, Litigation, Consent, Risk, and Governance — in real time</span>
    },
    {
      text: <span>Patent-Pending Architecture blending semantic AI, predictive dashboards, and multi-agent collaboration</span>
    }
  ];

  const bottomRowPills = [
    {
      text: <span>Built for Compliance from Day 1 — aligned with HIPAA, DPDP, SOC2, RBI/SEBI</span>
    },
    {
      text: <span>Enterprise-Grade Deployment — secure, scalable, and integration-ready</span>
    }
  ];

  const renderPill = (pill, index) => (
    <div key={index} className="competency-pill">
      <span className="competency-icon">
        {pill.icon}
      </span>
      {pill.text}
    </div>
  );

  return (
    <>
      <Helmet>
        <title>Cognitva - Your Enterprise-Wide Intelligence Layer</title>
        <meta name="description" content="Cognitva is your enterprise-wide intelligence layer, built on the Cross-Industry Intelligence Platform (CIP). It powers smart co-pilots, automates workflows, and predicts outcomes across every function and vertical." />
        <link rel="canonical" href="/" />
        <meta property="og:title" content="Cognitva - Your Enterprise-Wide Intelligence Layer" />
        <meta property="og:description" content="Cognitva is your enterprise-wide intelligence layer, built on the Cross-Industry Intelligence Platform (CIP). It powers smart co-pilots, automates workflows, and predicts outcomes across every function and vertical." />
        <meta property="og:image" content="/companylogo.svg" />
        <meta property="og:url" content="https://www.cognitva.ai/" />
      </Helmet>
      <section className="hero-section">
        <div className="ellipse63-bg">
          <img src="/images/ellipse63.svg" alt="Ellipse Decorative" />
        </div>
        <div className="hero-container">
          <div className="hero-badge">
            <span className="hi-icon" role="img" aria-label="waving hand">👋</span>
            <span>Meet Cognitva — your enterprise-wide intelligence layer</span>
          </div>

          <h1 className="section_title">
            <span className="make_italics"><em>One AI.</em></span>
            Infinite Roles. Built for Every Industry.
          </h1>

          <p className="hero-description">
            Built on Cognitva CIP™, the Cross-Industry Intelligence Platform that powers smart co-pilots, automates workflows, and predicts outcomes — Cognitva doesn't just automate. It thinks, adapts, and scales across every function and every vertical, transforming how your enterprise works.
          </p>

          <div className="core-competencies">
            <h3 className="section-title">Core Capabilities</h3>

            {/* Top row - scrolls left to right */}
            <div className="competency-row">
              <div className="competency-scroll-container">
                {/* Render pills multiple times for seamless infinite scrolling */}
                {[...Array(8)].map((_, setIndex) =>
                  topRowPills.map((pill, pillIndex) =>
                    renderPill(pill, `top-${setIndex}-${pillIndex}`)
                  )
                )}
              </div>
            </div>

            {/* Bottom row - scrolls right to left */}
            <div className="competency-row">
              <div className="competency-scroll-container">
                {/* Render pills multiple times for seamless infinite scrolling */}
                {[...Array(12)].map((_, setIndex) =>
                  bottomRowPills.map((pill, pillIndex) =>
                    renderPill(pill, `bottom-${setIndex}-${pillIndex}`)
                  )
                )}
              </div>
            </div>
          </div>

          <EmailSubscription onJumpIconClick={() => {
            console.log('Jump icon clicked');
            sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
          }} />
        </div>
      </section>
      <div ref={sectionRef}><WhyCognitva /></div>
      <WhyNow />
      {featureFlags.home.showTestimonials ? <Testimonials /> : <Divider />}
      <RequestInfo />
    </>
  );
};

export default HomePage;